export default {
  active: "bool",
  created_at: "date",
  id: "number",
  id_user: "number",
  id_group: "number",
  id_project: "number",
  created_time: "date",
  is_complete: "bool",
  is_new: "bool",
  is_ok: "bool",
  desc_ok: "bool",
  json: "json",
  finished: "bool",
  result_ok: "bool"
}
